var validateContactUsForm = function () {
	var validateContactForm = new forms4i(),
	contactForm = document.getElementById("contactUsForm"),
	confirmationMsg = document.getElementById("confirmationMessage"),
	successMsg = document.getElementById("contactFrmConfirm"),
	errorMsg = document.getElementById("contactFrmError"),
	recaptchaErrorMsg = document.getElementById("contactFrmRecaptchaError"),
	recaptchaVerificationLink = document.getElementById("contactFrmRecaptchaLink"),
	loadingIcon = document.getElementById("loadingIcon"),
	
	getAjaxHeader = function(selector) {		  
		return { "__RequestVerificationToken": selector.getElementsByTagName('input')[0].getAttribute("value") };
	},
	//verificationToken = document.getElementsByTagName('input')[0].getAttribute("value"),
	verificationToken = document.getElementsByName("__RequestVerificationToken")[0].value,
	submitContactUs = function() {	
		loadingIcon.classList.remove("hide");
		
		document.getElementById("btnContactUsSubmit").disabled = true;
		
		var recaptchaSiteKey = document.getElementsByClassName("recaptchaSiteKey")[0].value.toString();
		var recaptchaActionName = document.getElementsByClassName("recaptchaActionName")[0].value.toString();
		
		grecaptcha.execute(recaptchaSiteKey, { action: recaptchaActionName })
			.then(function(token) {

				var contactRequest = {
					FromEmail: document.getElementById("Email").value,
					EmailMessage: document.getElementById("Message").value,
					Subject: document.getElementById("Subject").value,
					RecaptchaActionName: recaptchaActionName,
					RecaptchaToken: token
				};
					        			
				fetch('default/contactus', { 
					method: 'POST', 
					body: JSON.stringify(contactRequest), 
					headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": verificationToken, "RequestVerificationToken": verificationToken }
				}).then(function(response){
					return  (response.ok) ? response.json() : []; // response.json() returns a promise
				}).then(function(response){
					if (!response.modelStateInvalid) {
			   			confirmationMsg.classList.remove("hide");
						contactForm.classList.add("hide");
						if (!response.success) {
							if (response.recaptchaFailed) {
								recaptchaVerificationLink.setAttribute("href", response.recaptchaUrl);
								recaptchaErrorMsg.classList.remove("hide");
							}
							else {
								errorMsg.classList.remove("hide");
							}
							successMsg.classList.add("hide");
						}
						confirmationMsg.scrollIntoView({behavior: "smooth"});
					}
					else {
			    			var formHeading = document.getElementsByClassName("formHeading")[0];
						formHeading.insertAdjacentHTML('afterend', response.validationSummary);
			    			formHeading.scrollIntoView({behavior: "smooth"});
						loadingIcon.classList.add("hide");
					}
					document.getElementById("btnContactUsSubmit").disabled = false;
				}).catch(function(error){
					//confirmationMsg.classList.remove("hide");
					//contactForm.classList.add("hide");
					errorMsg.classList.remove("hide");
					successMsg.classList.add("hide");
					confirmationMsg.scrollIntoView({behavior: "smooth"});
					document.getElementById("btnContactUsSubmit").disabled = false;
				});
			});
	},
	
	formSuccess = function() {
		submitContactUs();
    		confirmationMsg.scrollIntoView({behavior: "smooth"});
	},
	
	init = function() {
		if (document.getElementById("btnContactUsSubmit")) {
			document.getElementById("btnContactUsSubmit").addEventListener("click", function(e){
				e.preventDefault();
				validateContactForm.formValidation(contactForm, formSuccess, e);
			});
		} 
	};
	
	return {
		init: init
	};
	
};

(function() {
	var contactUsForm = new validateContactUsForm();
	contactUsForm.init();
})();